<template>
  <v-card>
    <v-card-title>
      <v-icon left>fas fa-history</v-icon>
      Process History
    </v-card-title>
    <v-divider />
    <template v-for="item in processes">
      <div :key="item.id + `-myTool`" class="mt-1 ml-1 pl-1 pt-1">
        <div v-if="isToolView">
          <span class="body-2">Work Order: </span>
          <WorkOrderNavigation :instance="item.workorder" />
        </div>
        <div v-else>
          <span class="body-2">Assigned To: </span>
          <ToolNavigation :toolname="item.tool.name" />
        </div>
      </div>
      <v-list :key="item.id" dense v-if="!item.migrated">
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="orange" small>fas fa-shower</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.prettyTimes().que_start }}
            </v-list-item-title>
            <v-list-item-subtitle>Que Start</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>
              Days Qued
            </v-list-item-action-text>
            {{ item.que_duration }}
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="!item.in_que">
          <v-list-item-icon>
            <v-icon color="primary" small>fas fa-running</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.prettyTimes().process_start }}
            </v-list-item-title>
            <v-list-item-subtitle>Process Start</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>
              Days Processing
            </v-list-item-action-text>
            {{ item.process_duration }}
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="item.completed">
          <v-list-item-icon>
            <v-icon color="green" small>fas fa-check-double</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.prettyTimes().process_end }}
            </v-list-item-title>
            <v-list-item-subtitle>Process End</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider :key="item.id + `-divider`"/>
    </template>
  </v-card>
</template>

<script>
import ToolNavigation from "./ToolNavigation";
import WorkOrderNavigation from "../WorkOrders/WorkOrderNavigation";
export default {
  name: "ToolProcessHistory",
  components: { WorkOrderNavigation, ToolNavigation },
  props: {
    processes: {
      type: [Array],
      required: true
    },
    isToolView: {
      type: Boolean,
      required: true,
      default: true
    }
  }
}
</script>
